module.exports = __webpack_public_path__ + "static/media/digital-dollars-menu.4465a8ca.png";